__turbopack_context__.v({
  "multiLine": "truncateText-module-scss-module__i83IRG__multiLine",
  "singleLine": "truncateText-module-scss-module__i83IRG__singleLine",
  "tooltip": "truncateText-module-scss-module__i83IRG__tooltip",
  "tooltipContainer": "truncateText-module-scss-module__i83IRG__tooltipContainer",
  "wrapper": "truncateText-module-scss-module__i83IRG__wrapper",
});
